import React, { Component, Fragment } from "react";
import styled from "styled-components";
import * as Icon from "../Icon";
import AppConfig from "../../Config";
import TreeNodeWrapper from "../FilterPanelTreeNode";

const OwnConfig = AppConfig["Components/FilterPanel"];

class FilterPanel extends Component {
  render() {
    return (
      <>
        <DesktopFilterPanel {...this.props} />
        <MobileFilterPanel {...this.props} />
      </>
    );
  }
}

const FilterTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  font-size: 14px;
  color: black;
  ${props => props.css}
`;

class DesktopFilterPanel extends Component {
  render() {
    let { activeFilter, onFilterItemClick, labels } = this.props;
    return (
      <Wrapper>
        <FilterTitle css="margin-bottom: 30px;">
          <Icon.List color="black" size={26} style={{ marginRight: 10 }} />
          <div>分類</div>
        </FilterTitle>

        {labels.map((label, lidx) => {
          if (label.children.length > 0) {
            return (
              <Fragment key={lidx}>
                {label.children.map((children, index) => (
                  <TreeNodeWrapper
                    key={index}
                    onNodeClick={node => onFilterItemClick(node)}
                    activeNode={activeFilter}
                    node={children}
                  />
                ))}
              </Fragment>
            );
          }
        })}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  @media screen and (max-width: ${OwnConfig.breakPointTablet}px) {
    display: none;
  }

  background-color: white;
  position: sticky;
  top: ${AppConfig.global.navbarHeight}px;
  bottom: 150px;
  display: flex;
  align-self: flex-start;
  flex-direction: column;
  padding: 10px 20px;
  width: 225px;
  min-height: 100px;
  justify-content: flex-start;
`;

class MobileFilterPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    };
  }

  render() {
    let { activeFilter, onFilterItemClick, labels } = this.props;
    let { visible } = this.state;

    return (
      <MobileWrapper visible={visible}>
        {visible && (
          <MobileBackdrop onClick={() => this.setState({ visible: false })} />
        )}

        <div
          className="ribbon-btn"
          onClick={() => this.setState({ visible: true })}
        >
          <Icon.List size={20} color={"rgb(78, 78, 78)"} />
          <span style={{ marginLeft: 5 }}>分類</span>
        </div>

        <MobileContainer visible={visible}>
          <FilterTitle css="margin-bottom: 30px;">
            <Icon.List color="#4e4e4e" size={26} style={{ marginRight: 10 }} />
            <div>分類</div>
          </FilterTitle>

          {labels.map((label, lidx) => {
            if (label.children.length > 0) {
              return (
                <Fragment key={lidx}>
                  {label.children.map((children, index) => (
                    <TreeNodeWrapper
                      key={index}
                      onNodeClick={node => onFilterItemClick(node)}
                      activeNode={activeFilter}
                      node={children}
                    />
                  ))}
                </Fragment>
              );
            }
          })}
        </MobileContainer>
      </MobileWrapper>
    );
  }
}

const MobileWrapper = styled.div`
  @media screen and (min-width: ${OwnConfig.breakPointTablet + 1}px) {
    display: none;
  }

  position: fixed;
  top: 90px;
  left: 0px;
  z-index: ${props => (props.visible ? 100 : 5)};

  & > .ribbon-btn {
    cursor: pointer;
    position: relative;
    padding: 12px 12px 12px 30px;
    background: #d8cbbf;
    min-width: 120px;
    text-align: center;
    letter-spacing: 2px;
    font-size: 16px;
    color: rgb(78, 78, 78);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);

    display: flex;
    align-items: center;

    &::before {
      content: "";
      width: 0;
      height: 0;

      position: absolute;
      top: 0;
      left: 117px;
      border-top: 35px solid #d8cbbf;
      border-right: 35px solid transparent;
    }

    &::after {
      content: "";
      width: 0;
      height: 0;

      position: absolute;
      bottom: 0;
      left: 117px;
      border-right: 35px solid transparent;
      border-bottom: 35px solid #d8cbbf;
    }
  }
`;

const MobileBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.2);
`;

const MobileContainer = styled.div`
  position: fixed;
  top: 0px;
  left: ${props => (props.visible ? "0px" : "-220px")};
  background-color: #d8cbbf;
  width: 220px;
  min-height: 100vh;
  padding: 50px 20px;
  overflow: auto;
  transition: left 200ms;
`;

export default FilterPanel;
